<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回">
      </f7-nav-left>
      <f7-nav-title>任务招标信息</f7-nav-title>
    </f7-navbar>
    <div class="has-content" style="padding-top: 1rem; padding-bottom: 1rem;">
      <div class="bid-title">
          <span>{{ bid.name }}</span>
      </div>
      <div style="display: flex;" v-if="(bid.path || []).length > 0">
        <div class="bid-sub-title">
          <div
            v-for="(pi, index) in (bid.path || [])"
            :key="bid.id+pi"
            v-show="bid.pathDisplay
              || (index === (bid.path || []).length - 1)">
            |&nbsp;&nbsp;{{ pi }}
          </div>
        </div>
        <div style="width: 1.85rem; color: #D3D3D3; cursor: pointer;">
          <div @click="bid.pathDisplay=!bid.pathDisplay">
            <f7-icon
              :material="bid.pathDisplay?'arrow_drop_up':'arrow_drop_down'">
            </f7-icon>
          </div>
        </div>
      </div>
      <div class="summary-text">
        <div>{{ bid.projectTypeDesc }}</div>
        <div>{{ bid.projectSize | formatNumberVal }} {{ bid.sizeUnitDesc }}</div>
        <div>{{ bid.prePrice | formatPriceVal }} {{ bid.priceUnitDesc }}</div>
      </div>
      <div class="line-horizontal">&nbsp;</div>
      <div>
        <div class="strong-text">任务信息：</div>
        <div class="content-text">招标单位：{{ bid.dutyDepartmentName }}</div>
        <div class="content-text">工程地址：{{ bid.address }}</div>
        <div class="content-text">项目类别：{{ bid.projectTypeDesc }}</div>
        <div class="content-text">
          工程规模：{{ bid.projectSize | formatNumberVal }}&nbsp;{{ bid.sizeUnitDesc }}
        </div>
        <div class="content-text" v-if="bid.type === 'assistProject'">
          任务性质：{{ bid.projectCharacterDesc }}
        </div>
        <div class="content-text">
          开竣工日期：
          {{ bid.planStartupTime | formatDateValue }}
          至
          {{ bid.planCompletedTime | formatDateValue }}
        </div>
        <div class="content-text" v-if="bid.type === 'normalProject'">
          所需人数：{{ bid.needUserNumber }}
        </div>
        <div class="content-text" v-if="bid.type === 'normalProject'">
          分包范围：{{ (bid.dutyScope || '').split('||').join('、') }}
        </div>
        <div class="content-text" v-if="bid.type === 'normalProject'">
          分包方式：{{ bid.subpackageModeDesc }}
        </div>
        <div class="content-text">结算方式：{{ bid.settlementDesc }}</div>
        <div class="content-text">
          分包单价：{{ bid.prePrice | formatNumberVal }}&nbsp;{{ bid.priceUnitDesc }}
        </div>
        <div class="content-text" v-if="bid.type === 'normalProject'">
          付款方式：{{ bid.payMethodDesc }}
        </div>
        <div class="content-text">
          辅料：{{ (bid.assistMaterials || []).join('，') }}
        </div>
        <div class="content-text" v-if="bid.type === 'assistProject'">
          福利待遇: {{ (bid.workerBenefits || []).join('，') }}
        </div>

        <div class="strong-text">投标要求：</div>
        <div class="content-text">队伍类型：{{ bid.receptCompanyTypeDesc }}</div>
        <div class="content-text">专业特长：{{ bid.receptFeaturesDesc }}</div>
        <div class="content-text">质量标准：{{ bid.qualityStandardDesc }}</div>
        <div class="content-text">投标说明：{{ bid.remark }}</div>

        <div class="strong-text">联系信息：</div>
        <div class="content-text">联系人：{{ bid.contactpeopleName }}</div>
        <div class="content-text">联系电话：{{ bid.contactpeoplePhone }}</div>
        <div class="content-text">截止日期：{{ bid.validityDate | formatDateValue }}</div>
      </div>
      <div>
        &nbsp;
      </div>
      <div class="line-horizontal">&nbsp;</div>
      <div>
        <div class="strong-text">工程信息</div>
        <div class="content-text">工程名称：{{ bid.name }}</div>
        <div class="content-text">工程地址：{{ bid.address }}</div>
        <div class="content-text">建设单位：{{ bid.buildDepartment }}</div>
        <div class="content-text">总包单位：{{ bid.totalDepartment }}</div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import currency from 'currency.js';
import { dateFormat } from '@/util/dateUtils';
import { getBidInfo } from '@/api/bid';

export default {
  props: ['id'],
  data() {
    return {
      bid: {},
    };
  },
  filters: {
    formatDateValue: value => dateFormat(value),
    formatNumberVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '--';
    },
    formatPriceVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '面议';
    },
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getBidInfo({ id: this.id }).then((result) => {
        if (result.code === 0) {
          this.bid = Object.assign(result.data || {}, { pathDisplay: false });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .bid-title {
    font-size: 1rem;
    font-weight: 700;
    padding: 0rem 0rem 0.5rem 0rem;
  }

  .bid-sub-title {
    font-size: 0.8rem;
  }

  .summary-text {
    color: $theme-color;
    display: flex;
    justify-content: space-around;
    padding-bottom: 0.8rem;
  }

  .strong-text {
    padding: 1rem 0rem 0.5rem 0rem;
    font-weight: 700;
  }

  .content-text {
    line-height: 1.5rem;
    padding-left: 0.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/bid/info.vue